import { Observable } from "rxjs";

import st from "lib/utils/index";
import { AgentCooperationsRepository } from "lib/repositories/index";
import { createResourceInstance, createFormInstance } from "modules/utils/index";

export const INITIALIZE_VIEW = "agents/EditAgentCooperationView/INITIALIZE_VIEW";
export const DESTROY_VIEW = "agents/EditAgentCooperationView/DESTROY_VIEW";

export const LOAD_COOPERATION = "agents/EditAgentCooperationView/LOAD_COOPERATION";
export const FETCH_COOPERATION = "agents/EditAgentCooperationView/FETCH_COOPERATION";
export const FETCH_COOPERATION_START = "agents/EditAgentCooperationView/FETCH_COOPERATION_START";
export const FETCH_COOPERATION_SUCCESS = "agents/EditAgentCooperationView/FETCH_COOPERATION_SUCCESS";
export const FETCH_COOPERATION_FAILURE = "agents/EditAgentCooperationView/FETCH_COOPERATION_FAILURE";

export const INITIALIZE_MODEL = "agents/EditAgentCooperationView/INITIALIZE_MODEL";
export const UPDATE_MODEL = "agents/EditAgentCooperationView/UPDATE_MODEL";
export const VALIDATE = "agents/EditAgentCooperationView/VALIDATE";
export const SUBMIT = "agents/EditAgentCooperationView/SUBMIT";
export const FETCH_SUBMIT_START = "agents/EditAgentCooperationView/FETCH_SUBMIT_START";
export const FETCH_SUBMIT_SUCCESS = "agents/EditAgentCooperationView/FETCH_SUBMIT_SUCCESS";
export const FETCH_SUBMIT_FAILURE = "agents/EditAgentCooperationView/FETCH_SUBMIT_FAILURE";

export const REMOVE = "agents/EditAgentCooperationView/REMOVE";
export const FETCH_REMOVE_START = "agents/EditAgentCooperationView/FETCH_REMOVE_START";
export const FETCH_REMOVE_SUCCESS = "agents/EditAgentCooperationView/FETCH_REMOVE_SUCCESS";
export const FETCH_REMOVE_FAILURE = "agents/EditAgentCooperationView/FETCH_REMOVE_FAILURE";

export const stateSelector = (state) => state.agents.EditAgentCooperationView;

const resourceInstance = createResourceInstance({
  LOAD: LOAD_COOPERATION,
  FETCH: FETCH_COOPERATION,
  FETCH_START: FETCH_COOPERATION_START,
  FETCH_SUCCESS: FETCH_COOPERATION_SUCCESS,
  FETCH_FAILURE: FETCH_COOPERATION_FAILURE,
  stateSelector,
  stateKey: "resource",
  getModel: ({ coopId }) => {
    return AgentCooperationsRepository.find(coopId);
  },
});

const formInstance = createFormInstance({
  INITIALIZE_MODEL,
  UPDATE_MODEL,
  VALIDATE,
  SUBMIT,
  FETCH_SUBMIT_START,
  FETCH_SUBMIT_SUCCESS,
  FETCH_SUBMIT_FAILURE,
  stateSelector,
  stateKey: "form",
  // validate
  submitModel: ({ form: { model: coop } }) => {
    return AgentCooperationsRepository.update(coop);
  },
});

const removalInstance = createResourceInstance({
  FETCH: REMOVE,
  FETCH_START: FETCH_REMOVE_START,
  FETCH_SUCCESS: FETCH_REMOVE_SUCCESS,
  FETCH_FAILURE: FETCH_REMOVE_FAILURE,
  stateSelector,
  stateKey: "removal",
  getModel: ({ coopId }) => {
    if (!coopId) {
      return Observable.empty();
    }
    return AgentCooperationsRepository.delete(coopId);
  },
});

const initialState = {
  resource: resourceInstance.initialState,
  form: formInstance.initialState,
  removal: removalInstance.initialState,
  coopId: null,
};

const reducers = {
  ...resourceInstance.reducersMap,
  ...formInstance.reducersMap,
  ...removalInstance.reducersMap,

  [INITIALIZE_VIEW]: (state, { coopId }) => ({
    ...initialState,
    coopId,
  }),
};

const epics = [
  ...resourceInstance.epics,
  ...formInstance.epics,
  ...removalInstance.epics,

  (actions$) => actions$.ofType(INITIALIZE_VIEW).mapTo(fetchAgentCooperation()),

  (actions$) =>
    actions$
      .ofType(LOAD_COOPERATION)
      .merge(actions$.ofType(FETCH_COOPERATION_SUCCESS))
      .map(({ model }) => initializeModel(model)),
];

export const { load: loadAgentCooperation, fetch: fetchAgentCooperation } = resourceInstance.actions;
export const { initializeModel, updateModel, validate, submit } = formInstance.actions;
export const { fetch: removeAgentCooperation } = removalInstance.actions;

export function initializeView({ coopId }) {
  return { type: INITIALIZE_VIEW, coopId };
}

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/agents/EditAgentCooperationView/index.js